/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
const ToolbarContext = createContext();
export default ToolbarContext;
//# sourceMappingURL=index.js.map